var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnviar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enviar",
    clipPath: "url(#clip0_130_719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0833 13.4167L20.6249 2.875",
    stroke: "#E0BA56",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6249 2.875L14.3957 20.125C14.3537 20.2168 14.2862 20.2945 14.2012 20.349C14.1163 20.4035 14.0175 20.4325 13.9166 20.4325C13.8156 20.4325 13.7168 20.4035 13.6319 20.349C13.5469 20.2945 13.4794 20.2168 13.4374 20.125L10.0832 13.4167L3.37488 10.0625C3.28313 10.0205 3.20538 9.95295 3.15087 9.86801C3.09636 9.78307 3.06738 9.68426 3.06738 9.58333C3.06738 9.48241 3.09636 9.3836 3.15087 9.29866C3.20538 9.21372 3.28313 9.14621 3.37488 9.10417L20.6249 2.875Z",
    stroke: "#E0BA56",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviar);
export default __webpack_public_path__ + "static/media/Enviar.f49264ef5a2be76b4a26186147be1e0f.svg";
export { ForwardRef as ReactComponent };